<template>
  <div class="commonCheckBox-wrap">
    <p class="title">
      {{ name }}
    </p>
    <div class="list">
      <div class="item" :class="{ active: props.modelValue.indexOf(index) > -1 }" v-for="(item, index) in itemList" :key="index"
        @click="handleChoose(index)">
        <span class="cir"></span>
        <span class="txt">{{ item }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  name: String,
  modelValue: Array,
  itemList: Array
})

const emit = defineEmits([
  "update:modelValue"
])

function handleChoose(index) {
  console.log("handleChoose");
  const arr = [].concat(props.modelValue);
  arr.indexOf(index) > -1 ? arr.splice(index, 1) : arr.push(index);
  console.log('arr :>> ', arr);
  emit("update:modelValue", arr);
}
</script>

<style scoped>
.commonCheckBox-wrap {
  width: 30.20833vw;
  margin: 0 auto;
}

.commonCheckBox-wrap .title {
  font-size: 0.9375vw;
  line-height: 1.30208vw;
  color: #2F3367;
  font-weight: bold;
  margin-bottom: 0.41666vw;
}

.commonCheckBox-wrap .list {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  row-gap: 3.2vw;
}

.commonCheckBox-wrap .list .item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-right: 3.64583vw;
  cursor: pointer;
}

.commonCheckBox-wrap .list .item:last-child {
  margin-right: 0;
}

.commonCheckBox-wrap .list .item .cir {
  display: block;
  width: 1.04166vw;
  height: 1.04166vw;
  box-sizing: border-box;
  border-radius: 0.3125vw;
  border: 0.05208vw solid #D4D6D8;
  margin-right: 0.72916vw;
}

.commonCheckBox-wrap .list .item .txt {
  min-width: 2.5vw;
  font-size: 0.83333vw;
  line-height: 1;
  color: #171A41;
}

.commonCheckBox-wrap .list .item.active .cir {
  background-color: #B41D22;
  border: none;
  background-image: url("../../assets/img/icons/icon-radio-check.png");
  background-repeat: no-repeat;
  background-size: 0.52083vw 0.52083vw;
  background-position: center center;
}

@media screen and (max-width: 750px) {

  .commonCheckBox-wrap {
    width: 82.93333vw;
  }

  .commonCheckBox-wrap .title {
    font-size: 3.73333vw;
    line-height: 5.33333vw;
    margin-bottom: 1.6vw;
  }

  .commonCheckBox-wrap .list .item {
    margin-right: 7.73333vw;
  }

  .commonCheckBox-wrap .list .item .cir {
    width: 4.26666vw;
    height: 4.26666vw;
    border-radius: 0.8vw;
    border-width: 0.26666vw;
    margin-right: 2.13333vw;
  }

  .commonCheckBox-wrap .list .item .txt {
    min-width: auto;
    font-size: 3.73333vw;
  }

  .commonCheckBox-wrap .list .item.active .cir {
    background-size: 60%;
  }

}
</style>